import React, { Component } from 'react';
import ClientForm from './clients/ClientForm';

export default class AddClient extends Component {

  render() {
    return (
      <div className='client-add-wrapper'>
        <div className='clientForm'>
          <ClientForm
            token={this.props.authToken}
            tenant={this.props.tenant}
            identification_types={this.props.identification_types}
            paraplannerWealthManagers={this.props.paraplannerWealthManagers}
            organizations={this.props.organizations}
            cohortsByOrg={this.props.cohortsByOrg}
            canInvite={this.props.canInvite}
            isProspect={this.props.isProspect} />
        </div>
      </div>
    )
  }
}
